import { API } from "aws-amplify";
import { updateLease } from "~/graphql/mutations";
import { EMPTY_LEASE_INFO } from "../getLeaseInfo";
import * as APITypes from "~/API";

export const editLease = async (payload: APITypes.UpdateLeaseInput) => {
  try {
    const response = (await API.graphql({
      query: updateLease,
      variables: {
        input: payload,
      },
    })) as { data?: APITypes.UpdateLeaseMutation };

    return {
      success: true,
      data: response.data?.updateLease || EMPTY_LEASE_INFO,
    };
  } catch (error) {
    console.error("Error editing lease", error);
    return {
      success: false,
      data: EMPTY_LEASE_INFO,
      error,
    };
  }
};
